import styled from "styled-components";
import {GameJackpotBarContainerDefaultBox} from "./game-jackpot-bar-container.default.box";
import {grayColors} from "../../../../../themes/architecture/gray-colors";
import {baseColors} from "../../../../../themes/definitions/mrgreen/base-colors";

export const GameJackpotBarContainerMrgreenBox = styled(GameJackpotBarContainerDefaultBox)<{isOptInStatus?: boolean}>`
    border: 1px solid ${({isOptInStatus}) => isOptInStatus ? baseColors.base03Contrast : grayColors.gray183};
`;
